module.exports = __webpack_public_path__ + "static/media/17.479e7ec7.png";